import React from "react"

import Footer from "../components/footer"
import NavigationSpacer from "../components/navigation-spacer"
import Seo from "../components/seo"

class Contact extends React.Component {
  render() {
    return (
      <div className="main-page h-100">
        <Seo title="Contact" description="Contact with me" />
        <div className="container-fluid d-flex flex-column main-mh-100">
          <NavigationSpacer />
          <div className="container flex-grow-1">
            <div className="row justify-content-center">
              <div className="col-md-10 col-xl-8">
                <h1 className="main-reveal-text-short mt-0">Contact</h1>
                <div className="main-fade-in-animation">
                  <p>
                  Вы можете отправить мне электронное письмо по адресу <code class="language-text">root.el.kali@gmail.com</code>.
                  </p>
              {/*}    <p>
                    Here is my <a aria-label="PGP key" href="/WhiteHoodHacker.asc">PGP key</a> if you wish to communicate using encryption.
                    <br />
                    Fingerprint: <code class="language-text">2019 FF0E 9A1B 845E 1614  EEDA DB2F 2FBF 62B4 9461</code>
                  </p>{*/}
                  <p>
                    В целях проверки мой тег Discord —  <a target="_blank" rel="noopener noreferrer" href="https://discordapp.com/users/777143638098313256">@hack1exe</a>, но я не принимаю запросы от незнакомцев. Вместо этого свяжитесь со мной по электронной почте.
                  </p>
                  <p>
                    Мой GitHub  —  <a target="_blank" rel="noopener noreferrer" href="https://github.com/hack1exe">hack1exe</a>.
                  </p>
                  <p>
                  Меня также можно найти в социальных сетях как <strong>@hack1exe</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    )
  }
}

export default Contact